import { lazy, Suspense, useEffect, useRef } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";

// Lazy load ALL components below the fold for better TTI
const About = lazy(() => import("@/components/About"));
const Services = lazy(() => import("@/components/Services"));
const Stats = lazy(() => import("@/components/Stats"));
const Team = lazy(() => import("@/components/Team"));
const Clients = lazy(() => import("@/components/Clients"));
const Transactions = lazy(() => import("@/components/Transactions"));
const Contact = lazy(() => import("@/components/Contact"));

// Minimal loading fallback - only visible briefly
const SectionFallback = () => (
  <div className="min-h-[100px]" />
);


// Section IDs that will be tracked
const TRACKED_SECTIONS = ['sobre', 'servicos', 'stats', 'transacoes', 'equipe', 'clientes', 'contato'];

const Index = () => {
  const trackingInitialized = useRef(false);
  
  // Lazy load section tracking to defer Supabase SDK
  useEffect(() => {
    if (trackingInitialized.current) return;
    trackingInitialized.current = true;
    
    // Load tracking after page is interactive
    const initTracking = () => {
      import('@/hooks/useSectionTracking').then(({ useSectionTrackingImperative }) => {
        useSectionTrackingImperative(TRACKED_SECTIONS);
      });
    };
    
    if (document.readyState === 'complete') {
      // Small delay to not block main thread
      setTimeout(initTracking, 100);
    } else {
      window.addEventListener('load', () => setTimeout(initTracking, 100), { once: true });
    }
  }, []);
  

  return (
    <main className="overflow-x-hidden">
      <Header />
      <Hero />
      <Suspense fallback={<SectionFallback />}>
        <About />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Services />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Stats />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Transactions />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Team />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Clients />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Contact />
      </Suspense>
    </main>
  );
};

export default Index;